import React from 'react';
import styled from 'styled-components';
import { Empty, Pagination } from 'antd';
import type { CollectForm_Base } from '~/common/typescript/models/CollectForm';
import type { Project_Base } from '~/common/typescript/models/Project';
import CollectFormItem from './CollectFormItem';

interface CollectFormGridProps {
  forms: CollectForm_Base[];
  projectsMap: Map<number, Project_Base>;
  onViewDetail: (form: CollectForm_Base) => void;
  onDelete: (uuid: string) => void;
  currentPage: number;
  pageSize: number;
  totalCount: number;
  onPageChange: (page: number, pageSize: number) => void;
}

export const CollectFormGrid: React.FC<CollectFormGridProps> = ({
  forms,
  projectsMap,
  onViewDetail,
  onDelete,
  currentPage,
  pageSize,
  totalCount,
  onPageChange,
}) => {
  if (forms.length === 0) {
    return (
      <UI_EmptyWrapper>
        <Empty description="Không có biểu mẫu nào trong dự án đã chọn" />
      </UI_EmptyWrapper>
    );
  }

  return (
    <UI_Container>
      <UI_Grid>
        {forms.map((form) => (
          <CollectFormItem
            key={form.uuid}
            form={form}
            project={projectsMap.get(form.project_id)}
            onViewDetail={onViewDetail}
            onDelete={onDelete}
          />
        ))}
      </UI_Grid>

      {totalCount > 0 && (
        <UI_PaginationWrapper>
          <Pagination
            current={currentPage}
            pageSize={pageSize}
            total={totalCount}
            onChange={onPageChange}
            showSizeChanger
            pageSizeOptions={['10', '20', '50']}
            showTotal={(total) => `Tổng cộng ${total} biểu mẫu`}
          />
        </UI_PaginationWrapper>
      )}
    </UI_Container>
  );
};

const UI_Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

const UI_Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 12px;
`;

const UI_PaginationWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  padding: 12px 0;
`;

const UI_EmptyWrapper = styled.div`
  padding: 60px 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #ffffff;
  border-radius: 8px;
  border: 1px dashed #e2e8f0;
`;
